import { render, staticRenderFns } from "./billindex.vue?vue&type=template&id=08b9e5f6&scoped=true&"
import script from "./billindex.vue?vue&type=script&lang=js&"
export * from "./billindex.vue?vue&type=script&lang=js&"
import style0 from "./billindex.vue?vue&type=style&index=0&id=08b9e5f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b9e5f6",
  null
  
)

export default component.exports